module.exports = __webpack_public_path__ + "static/media/category11.2783e9b5.png";